<template>
  <div class="row">

    <BootstrapInput
        @input-changed="changeForInput1"
        :input="input1Props"
        :scope="scope"
        :disabled="input1Disabled"
    />
    <input type="hidden"
           :name="`${scope}[${input1.attribute}]`"
           :value="inactiveValue1"
           :disabled="inactiveValue1 === null || activeAttribute === input1.attribute"
    >
    <BootstrapInput
        @input-changed="changeForInput2"
        :input="input2Props"
        :scope="scope"
        :disabled="input2Disabled"
    />
    <input type="hidden"
           :name="`${scope}[${input2.attribute}]`"
           :value="inactiveValue2"
           :disabled="inactiveValue2 === null || activeAttribute === input2.attribute"
    >
  </div>
</template>

<script>
import { InputProps } from "./BootstrapInput.vue";
import BootstrapInput from "./BootstrapInput.vue";

  export default {
    name: "ExclusiveInputs",
    components: { BootstrapInput },
    props: {
      scope: String,
      input1: {
        type: Object,
        required: true
      },
      input2: {
        type: Object,
        required: true
      },
    },
    data() {
      let attribute = null
      if(this.input1.value !== '' && this.input1.value !== null)
        attribute = this.input1.attribute
      if(this.input2.value !== '' && this.input2.value !== null)
        attribute = this.input2.attribute

      return {
        inactiveValue1: null, // Value to submit if this field is
        inactiveValue2: null,
        activeAttribute: attribute,
      }
    },
    computed:{
      input1Props() { return new InputProps({...this.input1}) } ,
      input2Props() { return new InputProps({...this.input2}) } ,
      input1Disabled() {
        return this.activeAttribute && this.activeAttribute !== this.input1.attribute
      },
      input2Disabled() {
        return this.activeAttribute && this.activeAttribute !== this.input2.attribute
      }
    },
    methods: {
      changeForInput1(input, change) {
        let attributeIsActive = change !== '' && change !== null && input.value !== change
        this.inactiveValue1 = attributeIsActive ? null : change
        this.activeAttribute = attributeIsActive ? input.attribute : null
      },
      changeForInput2(input, change) {
        let attributeIsActive = change !== '' && change !== null && input.value !== change
        this.inactiveValue2 = attributeIsActive ? null : change
        this.activeAttribute = attributeIsActive ? input.attribute : null
      }
    }
  }
</script>